import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import "../../styles/about-section.css";
import aboutImg from "../../assets/all-images/cars-img/nissan-offer.png";
import AOS from 'aos';
import "aos/dist/aos.css";

const AboutSection = ({ aboutClass }) => {
  useEffect(()=>{
    AOS.init({ duration: 800 })
  },[])
  return (
    <section
      className="about__section"
      style={
        aboutClass === "aboutPage"
          ? { marginTop: "0px" }
          : { marginTop: "3rem" }
      }
      data-aos="fade-up"
    >
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="about__section-content">
              <h4 className="section__subtitle">About Us</h4>
              <h2 className="section__title">Welcome to Kim Cab Services</h2>
              <p className="section__description">
                At <strong>Kim Cabs</strong>, we redefine travel with a
                commitment to professionalism, precision, and passenger
                satisfaction. Our services cut across all your needs, Travel, Comfort, Information, and Adventure.<br/><br/>
                Some of the qualities we brag about are:
              </p>

              <div className="about__section-item d-flex align-items-center">
                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i> 
                  Well maintained cars
                </p>

                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i> 
                  Experienced Chauffeur
                </p>
              </div>

              <div className="about__section-item d-flex align-items-center">
                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i> 
                  Passenger Satisfaction
                </p>

                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i>
                  Profesionalism and Precision
                </p>
              </div>
            </div>
          </Col>

          <Col lg="6" md="6">
            <div className="about__img">
              <img src={aboutImg} alt="" className="w-100" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
